/**
 * Content Section Renderer (Issue #933)
 *
 * Renders a content section with title and blocks.
 * Uses Layer 2 CSS tokens per ORO design system.
 *
 * Composition:
 * - Section title (h3)
 * - Array of ContentBlock elements
 */

import type { ContentSection } from '../../types/cms';
import { ContentBlockRenderer } from './ContentBlockRenderer';

interface ContentSectionRendererProps {
  section: ContentSection;
}

export function ContentSectionRenderer({ section }: ContentSectionRendererProps) {
  return (
    <div className="space-y-3">
      <h3 className="font-semibold text-text-primary">
        {section.title}
      </h3>
      {section.blocks.map((block, i) => (
        <ContentBlockRenderer key={i} block={block} />
      ))}
    </div>
  );
}
